<script>
 export default {
   name: 'NoteBadge',
 };
</script>

<template>
  <b-badge variant="light"><slot> Note </slot></b-badge>
</template>
